import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { PreferenzaAgenzia } from 'src/app/models/preferenza-agenzia';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { PreferenzaAgenziaService } from '../../services/preferenza-agenzia.service';
import { EditPreferenzaAgenziaComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'preferenze-agenzie',
  templateUrl: './preferenze-agenzie.component.html',
  styleUrls: ['./preferenze-agenzie.component.scss']
})
export class PreferenzeAgenzieComponent implements OnInit {

  headingText: string = 'Preferenze Agenzie';

  relations: string[] = ['agenzia', 'incaricato'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Agenzia',
        internalName: 'agenzia',
        displayFunction: model => model?.agenzia?.humanIdentifier
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Incaricato',
        internalName: 'incaricato',
        displayFunction: model => model?.incaricato?.humanIdentifier
      }
    ),
  ];

  constructor(
    public preferenzaAgenziaService: PreferenzaAgenziaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    private fb: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<PreferenzeAgenzieComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una preferenza agenzia';
    }
  }

  form: FormGroup;

  ngOnInit() {
    this.form = this.fb.group({
      agenzia: [],
      incaricato: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);
  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }

  deleteFunction = async (preferenza: PreferenzaAgenzia) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Eliminare la preferenza per ${preferenza?.agenzia?.humanIdentifier}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.preferenzaAgenziaService.delete(preferenza);
          this.toast.success('Preferenza eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione preferenza fallita.", "Errore!");
    }
  }

  editFunction = async (preferenza: PreferenzaAgenzia) => {
    try {
      let dialogRef = this.dialog.open(EditPreferenzaAgenziaComponent, { data: preferenza });
      dialogRef.afterClosed().subscribe(async (data: PreferenzaAgenzia) => {
        if (data) {
          Object.assign(preferenza, {
            ...data,
            agenzia_id: data?.agenzia?.id,
            incaricato_id: data?.incaricato?.id
          });

          await this.preferenzaAgenziaService.edit(preferenza);

          this.toast.success('Preferenza aggiornata');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica preferenza fallita.", "Errore!");
    }
  }

  add() {
    let addDialogRef = this.dialog.open(EditPreferenzaAgenziaComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(preferenza?: PreferenzaAgenzia) {
    if (preferenza) {
      try {
        await this.preferenzaAgenziaService.create(preferenza)
        this.toast.success('Preferenza creata!')
      }
      catch (e) {
        this.toast.error('Creazione preferenza fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }
}
